import {
    Button,
    IconButton,
    ListItem,
    ListItemIcon,
    ListItemText,
    makeStyles,
} from "@material-ui/core"
import { Delete as DeleteIcon, Edit as EditIcon, Payment as PaymentIcon } from "@material-ui/icons"
import { useContext } from "react"
import SiteContext from "../../../contexts/SiteContext"

const useStyles = makeStyles(theme => ({
    container: {
        display: "grid",
        gridTemplateColumns: "1fr min-content min-content",
        gap: "max(0.375rem, 2%)",
        alignItems: "center",
        justifyItems: "center",
        border: "1px solid rgba(0, 0, 0, 0.23)",
        borderRadius: "4px",
        margin: "12px 0",
        "&:hover": {
            borderColor: "rgba(0, 0, 0, 0.87)",
        },
        "& svg": {
            fontSize: "2rem",
            color: "rgba(0, 0, 0, 0.54)",
        },
        "& > .icon-container": {},
        "& > button": {
            padding: "0.25rem",
        },
        "& svg": {
            fontSize: "min(1.75rem, 7vw)",
        },
        "& .nome-cartao": {
            fontSize: "min(3.5vw, 0.875rem)",
            overflow: "hidden",
            textWrap: "nowrap",
        },
    },
    container_selecionar: {
        border: "1px solid rgba(0, 0, 0, 0.23)",
        borderRadius: "4px",
        margin: "12px 0",
        "&:hover": {
            borderColor: "rgba(0, 0, 0, 0.87)",
        },
    },
    cartaoItemLista: {
        display: "flex",
        padding: 0,
        "& > div": {
            margin: "0.125rem",
            padding: "0.25rem 0.75rem",
            [theme.breakpoints.down("xs")]: {
                padding: "0.25rem 0.25rem",
            },
        },
        "& .icon-container": {
            [theme.breakpoints.down("xs")]: {
                display: "none",
            },
        },
    },
}))

function DisplayDetalhesCartao(props) {
    const { carrinho, setCarrinho, usuarioLogado } = useContext(SiteContext)

    const classes = useStyles()

    const isPagSeguro = carrinho.pedido.formaPagamento?.id === 71

    if (!isPagSeguro) return null

    const handleEdit = () => props.setAbrirDialogCadastroCartao(true)

    const handleRemove = () =>
        setCarrinho({
            ...carrinho,
            pedido: {
                ...carrinho.pedido,
                cartaoCreditoCliente: null,
            },
        })

    const cartao = carrinho.pedido.cartaoCreditoCliente

    if (!cartao)
        return (
            <div className={classes.container_selecionar}>
                <Button onClick={handleEdit} fullWidth>
                    Selecionar cartão
                </Button>
            </div>
        )

    const numeroCartaoFormatado = cartao.numeroCartao.replace("XXXX-XXXX-XXXX-", "•••• ")

    return (
        <div className={classes.container}>
            <ListItem className={classes.cartaoItemLista} component="div">
                <ListItemIcon className="icon-container">
                    <PaymentIcon />
                </ListItemIcon>
                <ListItemText
                    primary={numeroCartaoFormatado}
                    secondary={cartao.nomeImpressoCartao}
                    secondaryTypographyProps={{ className: "nome-cartao" }}
                />
            </ListItem>
            <IconButton onClick={handleEdit} className="icon-container">
                <EditIcon />
            </IconButton>
            <IconButton onClick={handleRemove} className="icon-container">
                <DeleteIcon />
            </IconButton>
        </div>
    )
}

export default DisplayDetalhesCartao
